<template>
  <div id="user-menu">
    <div class>
      <h5 class="mb-3">My Details</h5>
      <ul class="list-group">
        <router-link to="/me/">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onProfile }"
          >
            <i class="material-icons" style="margin-right:7px">person</i>My Profile
          </li>
        </router-link>
        <router-link to="/me/password">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onPassword }"
          >
            <i class="material-icons" style="margin-right:7px">lock</i>Change password
          </li>
        </router-link>
      </ul>
      <h5 class="my-3">My Content</h5>
      <ul class="list-group">
        <router-link to="/me/media">
          <li class="list-group-item d-flex align-items-center" v-bind:class="{ active: onMedia }">
            <i class="material-icons" style="margin-right:7px">perm_media</i>My media
          </li>
        </router-link>
        <router-link to="/me/scenarios">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onScenarios }"
          >
            <i class="material-icons" style="margin-right:7px">insert_chart_outlined</i>My scenarios
          </li>
        </router-link>
      </ul>
      <h5 class="my-3">Add Content</h5>
      <ul class="list-group">
        <router-link to="/media/upload">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onUploadMedia }"
          >
            <i class="material-icons" style="margin-right:7px">cloud_upload</i>Upload media
          </li>
        </router-link>
        <router-link to="/scenarios/upload">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onUploadScenario }"
          >
            <i class="material-icons" style="margin-right:7px">cloud_upload</i>Upload scenario
          </li>
        </router-link>
      </ul>
      <div v-if="user.canProvision" class="my-3">
        <h5>Provisioning</h5>
        <ul class="list-group">
          <router-link to="/me/provisioning">
            <li
              class="list-group-item d-flex align-items-center"
              v-bind:class="{ active: onProvisioning }"
            >
              <i class="material-icons" style="margin-right:7px">devices_other</i>Provision device
            </li>
          </router-link>
        </ul>
      </div>
      <div v-if="user.isPreRelease" class="my-3">
        <h5>Pre-Release</h5>
        <ul class="list-group">
          <router-link to="/me/pre-release">
            <li
              class="list-group-item d-flex align-items-center"
              v-bind:class="{ active: onPreReleases }"
            >
              <i class="material-icons" style="margin-right:7px">new_releases</i>View pre-releases
            </li>
          </router-link>
        </ul>
      </div>
<!--      <h5>Resources</h5>-->
<!--      <ul class="list-group">-->
<!--        <router-link to="/me/downloads">-->
<!--          <li-->
<!--            class="list-group-item d-flex align-items-center"-->
<!--            v-bind:class="{ active: onDownloads }"-->
<!--          >-->
<!--            <i class="material-icons" style="margin-right:7px">save_alt</i>Available downloads-->
<!--          </li>-->
<!--        </router-link>-->
<!--      </ul>-->
      <h5 class="my-3">Support</h5>
      <ul class="list-group">
        <router-link to="/me/support">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onSupport }"
          >
            <i class="material-icons" style="margin-right:7px">contact_support</i>Support information
          </li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import storage from "store";
export default {
  name: "UserMenu",
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  data() {
    return {
      onProfile: false,
      onPassword: false,
      onEditDetails: false,
      onUploadScenario: false,
      onScenarios: false,
      onUploadMedia: false,
      onMedia: false,
      onProvisioning: false,
      onSupport: false,
      onDownloads: false,
      onPreReleases: false
    };
  },
  beforeMount() {
    switch (this.$route.path) {
      case "/me/":
        this.onProfile = true;
        break;
      case "/me/profile":
        this.onEditDetails = true;
        break;
      case "/me/password":
        this.onPassword = true;
        break;
      case "/scenarios/upload":
        this.onUploadScenario = true;
        break;
      case "/me/scenarios":
        this.onScenarios = true;
        break;
      case "/media/upload":
        this.onUploadMedia = true;
        break;
      case "/me/media":
        this.onMedia = true;
        break;
      case "/me/provisioning":
        this.onProvisioning = true;
        break;
      case "/me/support":
        this.onSupport = true;
        break;
      case "/me/downloads":
        this.onDownloads = true;
        break;
      case "/me/pre-release":
        this.onPreReleases = true;
        break;
      default:
        this.onProfile = true;
        break;
    }
  }
};
</script>

<style scoped>
.list-group-item.active {
  color: #fff;
}
@media (min-width: 768px) {
  .collapse.dont-collapse-sm {
    display: block;
    height: auto !important;
    visibility: visible;
  }

  .list-group-item.active {
    color: #fff;
  }

  .list-group-item a {
    color: #333;
  }
  .list-group-item {
    color: #212529;
  }
}

ul.list-group li:not(:first-child a):not(:last-child a) {
  border-radius: 0px;
}

ul.list-group li :first-child a {
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child a {
  border-top-left-radius: 0px;
  border-top-left-radius: 0px;
}

#user-menu {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding-right: 15px;
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: #6c757d;
  margin-left: 0px;
}

i {
}
</style>
